module.exports = __webpack_public_path__ + "img/20180815_152858_231.b2eed1ea.jpg";